import Button from '@doordash/component-button'
import NavBar from '@doordash/component-navbar'
import { Text, StackChildren, Colors, Inset } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { Bottom, Container, TitleContainer } from './styles'
import t from './strings'
import ComponentListCell from '@doordash/component-list-cell'
import * as DA from '../../../typeModules/events'
import { getButtonState } from '../../../utilities/getButtonState'
import { BUTTON_STATES } from '../../../constants'

type MailingAddressConfirmationProps = {
  uniqueLink?: string
  mailingAddress?: {
    street: string
    streetLine2: string
    state: string
    city: string
    postalCode: string
    isSubmitting?: boolean
    isSubmitted?: boolean
    error: any
  }
  submitMailingAddress?: (
    uniqueLink,
    mailingAddress,
    application
  ) => Promise<any>
  updatePaymentAccount?: any
  paymentAccountId?: string
  application?: any
  back: () => void
  onSuccess: () => void
  track: (
    action: DA.EventActions,
    name: DA.AddressCollectionScreens
  ) => Promise<void>
}

export const MailingAddressConfirmation: React.FC<MailingAddressConfirmationProps> = ({
  mailingAddress,
  back,
  submitMailingAddress,
  updatePaymentAccount,
  paymentAccountId,
  application,
  uniqueLink,
  onSuccess,
  track,
}) => {
  React.useEffect(() => {
    track(DA.EventActions.Rendered, DA.AddressCollectionScreens.Confirmation)
  }, [track])

  const handleSubmit = async () => {
    track(DA.EventActions.Submit, DA.AddressCollectionScreens.Confirmation)
    if (paymentAccountId) {
      const payload = {
        address: {
          line1: mailingAddress.street,
          line2: mailingAddress.streetLine2,
          city: mailingAddress.city,
          postal_code: mailingAddress.postalCode,
          state: mailingAddress.state,
        },
      }
      await updatePaymentAccount(paymentAccountId, payload)
    }

    await submitMailingAddress(uniqueLink, mailingAddress, application)
  }
  const mailingAddressButtonState = {
    isSubmitting: mailingAddress.isSubmitting,
    isSubmitted: mailingAddress.isSubmitted,
    error: mailingAddress.error,
  }
  return (
    <React.Fragment>
      <NavBar
        isSeparatorVisible={false}
        onNavigationClick={() => {
          track(DA.EventActions.Back, DA.AddressCollectionScreens.Confirmation)
          back()
        }}
      />
      <TitleContainer>
        <Text styles={Text.Styles.Bold24}>{t.confirmation.title()}</Text>
      </TitleContainer>
      <Container>
        <Text styles={Text.Styles.Bold18}>{t.confirmation.list1.title()}</Text>
      </Container>
      <ComponentListCell
        title={t.confirmation.list1.item1()}
        size={ComponentListCell.Sizes.Small}
        secondaryTitleEnd={'x1'}
        insetSize={Inset.Sizes.Small}
        separatorType={ComponentListCell.SeparatorTypes.InsetBorder}
      />
      <ComponentListCell
        title={t.confirmation.list1.item2()}
        size={ComponentListCell.Sizes.Small}
        secondaryTitleEnd={'x1'}
        insetSize={Inset.Sizes.Small}
        separatorType={ComponentListCell.SeparatorTypes.FullBorder}
      />
      <br />
      <Container>
        <Text styles={Text.Styles.Bold18}>{t.confirmation.list2.title()}</Text>
      </Container>
      <ComponentListCell
        title={t.confirmation.list2.item1()}
        size={ComponentListCell.Sizes.Small}
        secondaryTitleEnd={mailingAddress.street}
        onClick={() => {
          track(
            DA.EventActions.Previous,
            DA.AddressCollectionScreens.Confirmation
          )

          back()
        }}
        iconEnd={{
          type: ComponentListCell.IconTypes.ChevronRight,
          color: Colors.TextPrimary,
        }}
        insetSize={Inset.Sizes.Small}
        separatorType={ComponentListCell.SeparatorTypes.InsetBorder}
      />
      <ComponentListCell
        title={t.confirmation.list2.item2()}
        size={ComponentListCell.Sizes.Small}
        secondaryTitleEnd={t.confirmation.eta()}
        insetSize={Inset.Sizes.Small}
        separatorType={ComponentListCell.SeparatorTypes.FullBorder}
      />
      <Bottom>
        <StackChildren>
          <Text
            textAlign={Text.TextAlignments.Center}
            styles={Text.Styles.Medium14}
            color={Colors.SystemGrey60}
          >
            {t.confirmation.primaryDescription()}
          </Text>
          <Button
            state={getButtonState(mailingAddressButtonState)}
            onClick={handleSubmit}
            onAnimationEnd={status => {
              if (status === BUTTON_STATES.Success) {
                track(
                  DA.EventActions.Success,
                  DA.AddressCollectionScreens.Confirmation
                )
                onSuccess()
              } else if (status === BUTTON_STATES.Error) {
                track(
                  DA.EventActions.Error,
                  DA.AddressCollectionScreens.Confirmation
                )
                back()
              }
            }}
          >
            {t.confirmation.primaryAction()}
          </Button>
        </StackChildren>
      </Bottom>
    </React.Fragment>
  )
}
const mapStateToProps = state => ({
  mailingAddress: state.mailingAddress,
  application: state.application,
  paymentAccountId: state.paymentAccount.id,
})

const mapDispatchToProps = {
  submitMailingAddress: actions.submitMailingAddress,
  updatePaymentAccount: actions.updatePaymentAccount,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailingAddressConfirmation)
